import "./header.scss";

const CSS_CLASSES = {
  logoLink: "glue-header__logo-link",
  pageLink: "glue-header__link",
  activePageLink: "glue-header__item--active",
};

export class HeaderComponent {
  element: HTMLElement;
  headerButtons: HTMLAnchorElement[];

  constructor(element: HTMLElement) {
    this.element = element;
    const logoButtons = Array.from(
      element.querySelectorAll<HTMLAnchorElement>(`.${CSS_CLASSES.logoLink}`)
    );
    const pagesButtons = Array.from(
      element.querySelectorAll<HTMLAnchorElement>(`.${CSS_CLASSES.pageLink}`)
    );
    this.headerButtons = [...logoButtons, ...pagesButtons];

    this.handlePageClick = this.handlePageClick.bind(this);

    this.init();
  }

  init() {
    this.initListeners();
    this.activateCurrent();
  }

  initListeners() {
    if (!this.headerButtons) return;

    this.headerButtons.forEach((headerButton) => {
      headerButton.addEventListener("click", this.handlePageClick);
    });
  }

  removeListeners() {
    this.headerButtons.forEach(headerButton => {
      headerButton.removeEventListener("click", this.handlePageClick);
    });
  }

  handlePageClick(event: Event) {
    event.preventDefault();
    const target = event.currentTarget as HTMLAnchorElement;

    if (window.location.href === target.href) {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.location.href = target.href;
      this.removeListeners();
    }
  }

  activateCurrent() {
    const url = new URL(window.location.href);
    const baseURL = `${url.origin}${url.pathname}`;

    this.headerButtons.forEach((headerButton) => {
      if (
        headerButton.href === baseURL &&
        headerButton.classList.contains(CSS_CLASSES.pageLink)
      ) {
        const container = headerButton.parentNode as HTMLElement;
        container.classList.add(CSS_CLASSES.activePageLink);
      }
    });
  }
}
